import { Typography, Button, Input, message, Checkbox } from "antd";
import { useState } from "react";
import "./amberModal.scss";
import { useUserFilesTabs } from "./UserFilesTabsContext";
import { patchPostFetcher } from "../../../utils/fetcher";
import { useLocation } from "react-router-dom";
import useSWRMutation from "swr/mutation";
import { mutate } from "swr";
import { AppModal } from "../../../components/common";

const { Text } = Typography;
const { TextArea } = Input;

type RedFlagPayload = {
  ambarStatus: boolean;
  reason: any;
};

export default function AmberModal() {
  const {
    amberModal,
    setAmberModal,
    amberChecked,
    SetamberChecked,
  } = useUserFilesTabs();


  const [confirmcheck, setConfirmcheck] = useState(false);



  const handleDraft = () => {
    SetamberChecked(false);
    console.log("Draft saved");
    setAmberModal(false);
     Setreason("");
      setConfirmcheck(false);
  };


  const API_URL = process.env.REACT_APP_API_URL;
  const location = useLocation();
  const clientId = location.pathname.split("/")[3];





  const { trigger: sessionReportTrigger, isMutating } = useSWRMutation<
    any,
    any,
    string | null,
    RedFlagPayload
  >(clientId ? `${API_URL}/session/ambar-toggle/${clientId}` : null, (url, { arg }) =>
    patchPostFetcher({
      url,
      data: arg,
      method: "POST",
    }),
  );
  const [reason,Setreason] = useState("")


  const handleSend = async () => {

     if (!reason?.trim()) {
    message.warning("Please enter a reason");
    return;
  }

    const payload: RedFlagPayload = {
      ambarStatus: amberChecked,
      reason: reason,
    };

    try {
      await sessionReportTrigger(payload);
      message.success("Updated Successfully");
      mutate(`${API_URL}/session/ambar-history/${clientId}`);

      Setreason("");
      setConfirmcheck(false);
      setAmberModal(false);
    } catch (err) {
      setAmberModal(false);
    }
  };

  return (
 <AppModal
   open={amberModal}
   title="Activate Exploratory Call & Initiate 72-Hour Support Window"
   className="redflagModal"
   onCancel={() => {
    setAmberModal(false);
    SetamberChecked(false);
  }}
 >
      <div className="confirmWrapper">
        <div className="confirmCard">
          <div className="confirmContent">
            <Text className="sectionTitle">What will happen:</Text>

            <ul>
              <li>
                A 72-hour complimentary counseling support window will be
                activated for this client
              </li>
              <li style={{margin:"0"}}>The client-facing notification flow will be initiated</li>
            </ul>

            <Text className="sectionTitle">Action Required:</Text>
            {/* <br /> */}

            <Text className="value_of">
              To proceed, you must select <b>at least one reason</b> for
              activating this trigger in the next step.
            </Text>
            {/* <br /> */}

            <Text className="value_of mar_16">
              The selected reason(s), along with any internal notes, will be
              stored securely in internal records and will not be visible to the
              client.
            </Text>
            {/* <br /> */}
            <Text className="sectionTitle">Important:</Text>
            {/* <br /> */}

            <Text className="value_of">
              Please activate the Exploratory Call Trigger only when
              appropriate. This action should be taken with professional
              discretion.
            </Text>
            {/* <br /> */}
            <Text className="sectionTitle">Confidentiality reminder</Text>
            {/* <br /> */}

            <Text className="value_of" style={{margin:"0"}}>
              All related actions and internal notes remain confidential and
              accessible only to authorized internal roles.
            </Text>
          </div>
        </div>

        <div>
          <p
            className="sectionTitle"
            style={{
              marginBottom: 16,
            }}
          >
            Reason for Activating Trigger<span className="required">*</span>
          </p>
          <TextArea className="text_delete" placeholder="Please enter the reason" onChange={(e)=>Setreason(e.target.value)} rows={4} />
        </div>
        <div className="confirmCheckboxRow">
          <Checkbox
            checked={confirmcheck}
            onChange={(e) => setConfirmcheck(e.target.checked)}
          />
          <Text className="value_to">
            I confirm that this escalation is necessary and appropriate and that
            I have reviewed the email content carefully.
          </Text>
        </div>

        <div className="confirmActions">
          <Button
            className="btnGreen"
            onClick={handleSend}
            disabled={!confirmcheck}
          >
            Activate Trigger & Start 72-Hour Support
          </Button>

          <Button className="btnRed" onClick={handleDraft}>
            Cancel
          </Button>
        </div>
      </div>
    </AppModal>
  );
}
